import { AfterViewChecked, Directive, ElementRef, Input, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[appSetPaddingBottom]'
})
export class SetPaddingBottomDirective implements AfterViewChecked {
  @Input({ required: true, alias: 'appSetPaddingBottom' }) targetSelector = '';
  private readonly elementRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  ngAfterViewChecked(): void {
    if (!this.targetSelector) {
      return;
    }

    const elementHeight = this.elementRef.nativeElement.offsetHeight;

    const targetElement = document.querySelector(this.targetSelector);

    if (targetElement && elementHeight > 0) {
      this.renderer.setStyle(targetElement, 'padding-bottom', `${elementHeight}px`);
    }
  }
}
